module.exports = __webpack_public_path__ + "static/media/VerticalLeftAdPreview.bad374d2.svg";